const cardNames = {
    // hearts
    a: {
        suit: 0,
        value: 0,
    },
    b: {
        suit: 0,
        value: 1,
    },
    c: {
        suit: 0,
        value: 2,
    },
    d: {
        suit: 0,
        value: 3,
    },
    e: {
        suit: 0,
        value: 4,
    },
    f: {
        suit: 0,
        value: 5,
    },
    g: {
        suit: 0,
        value: 6,
    },
    h: {
        suit: 0,
        value: 7,
    },
    // diamonds
    i: {
        suit: 1,
        value: 0,
    },
    j: {
        suit: 1,
        value: 1,
    },
    k: {
        suit: 1,
        value: 2,
    },
    l: {
        suit: 1,
        value: 3,
    },
    m: {
        suit: 1,
        value: 4,
    },
    n: {
        suit: 1,
        value: 5,
    },
    o: {
        suit: 1,
        value: 6,
    },
    p: {
        suit: 1,
        value: 7,
    },
    // spades
    q: {
        suit: 2,
        value: 0,
    },
    r: {
        suit: 2,
        value: 1,
    },
    s: {
        suit: 2,
        value: 2,
    },
    t: {
        suit: 2,
        value: 3,
    },
    u: {
        suit: 2,
        value: 4,
    },
    v: {
        suit: 2,
        value: 5,
    },
    w: {
        suit: 2,
        value: 6,
    },
    x: {
        suit: 2,
        value: 7,
    },

    // clubs

    y: {
        suit: 3,
        value: 0,
    },

    z: {
        suit: 3,
        value: 1,
    },
    A: {
        suit: 3,
        value: 2,
    },
    B: {
        suit: 3,
        value: 3,
    },
    C: {
        suit: 3,
        value: 4,
    },
    D: {
        suit: 3,
        value: 5,
    },
    E: {
        suit: 3,
        value: 6,
    },
    F: {
        suit: 3,
        value: 7,
    },
};

Object.freeze(cardNames);

export default cardNames;
